import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function OnboardingLayout({ title, subtitle, children, actions }) {
  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 4,
      // Gradient background similar to the mock
      background: 'linear-gradient(135deg, #6da2ff 0%, #c17bff 50%, #ff6fc2 100%)',
      // subtle pattern overlay
      backgroundImage: `linear-gradient(transparent 0%, rgba(255,255,255,0.02) 100%)`
    }}>
      <Paper sx={{
        width: '100%',
        maxWidth: 1100,
        borderRadius: 3,
        p: { xs: 4, md: 6 },
        boxShadow: '0 12px 40px rgba(15,23,42,0.18)',
        background: 'linear-gradient(180deg, rgba(255,255,255,0.12), rgba(255,255,255,0.06))'
      }} elevation={0}>
        <Box>
          {title && <Typography variant="h6" sx={{ letterSpacing: 0.6, fontWeight: 600 }}>{title}</Typography>}
          {subtitle && <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{subtitle}</Typography>}
          <Box sx={{ mt: 2 }}>{children}</Box>
          {actions && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              {actions}
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
}
